import './App.css';
import Navbar from './components/navBar';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

const programs = [
  {
    title: "🌼 Tiny Care",
    age: "1-2 Years",
    desc: "Comfort, sensory play and bonding."
  },
  {
    title: "🎈 Tiny Play",
    age: "2-3 Years",
    desc: "Music, movement and storytelling."
  },
  {
    title: "📚 Tiny KG",
    age: "3-4 Years",
    desc: "Letters, numbers and creativity."
  },
  {
    title: "✏️ Tiny Junior",
    age: "4-5 Years",
    desc: "Communication and confidence."
  },
  {
    title: "🎓 Tiny Senior",
    age: "5-6 Years",
    desc: "School readiness and leadership."
  }
];

function App() {
  return (
    <>
      <Navbar />

      <Hero />

     <section id="about" className="section about-section">
  <h2>About Tiny Toes</h2>

  <div className="about-card">
    <h3>🌈 Nurturing Little Minds, Building Bright Futures</h3>

    <p>
      At Tiny Toes Play School, we believe that every child is unique,
      curious, and full of potential. Our mission is to provide a safe,
      loving, and stimulating environment where children can learn,
      explore, and grow with confidence.
    </p>

    <p>
      We understand that the early years are the foundation of a child's
      future, and we are committed to making every learning experience
      meaningful, joyful, and memorable.
    </p>

    <p>
      Through play-based learning, storytelling, music, art, hands-on
      activities, and interactive experiences, we help children develop
      creativity, confidence, social skills, and a lifelong love for learning.
    </p>
  </div>

  <div className="vision-mission-grid">
    <div className="info-card vision">
      <h3>🌟 Our Vision</h3>

      <p>
        To inspire and empower young children to become confident,
        compassionate, creative, and lifelong learners by providing a
        nurturing environment where every child feels valued,
        respected, and encouraged to reach their full potential.
      </p>

      <p>
        We envision a future where children grow with strong values,
        curiosity, resilience, and the skills needed to thrive in an
        ever-changing world.
      </p>
    </div>

    <div className="info-card mission">
      <h3>🎯 Our Mission</h3>

      <ul>
        <li>Provide a safe, secure, and child-friendly learning environment.</li>
        <li>Encourage creativity, imagination, and independent thinking.</li>
        <li>Foster social, emotional, physical, and cognitive development.</li>
        <li>Build strong partnerships with parents and families.</li>
        <li>Make learning fun through play, exploration, and discovery.</li>
        <li>Celebrate every child's individuality and unique talents.</li>
      </ul>
    </div>
  </div>
</section>

      <section id="programs" className="section">
        <h2>Our Programs</h2>

        <div className="program-grid">
          {programs.map((program,index)=>(
            <div key={index} className="program-card">
              <h3>{program.title}</h3>
              <h4>{program.age}</h4>
              <p>{program.desc}</p>
            </div>
          ))}
        </div>
      </section>

    <section className="section why">
  <h2>Why Parents Choose Tiny Toes</h2>

  <div className="why-grid">
    <div className="why-card">🛡️ Safe, Clean & Child-Friendly Environment</div>
    <div className="why-card">👩‍🏫 Caring & Qualified Educators</div>
    <div className="why-card">🌟 Individual Attention for Every Child</div>
    <div className="why-card">🎨 Learning Through Play & Discovery</div>
    <div className="why-card">🌱 Holistic Child Development</div>
    <div className="why-card">🤝 Strong Parent-School Communication</div>
    <div className="why-card">🎉 Activities, Celebrations & Events</div>
  </div>
</section>

      <Gallery />

      <FAQ />

      <section id="contact" className="contact">
        <h2>Admissions Open!</h2>

        <div className="contact-card">
          <h3>📍 Plot No 41, Anantha Nagar, Anaiyur, Madurai - 17</h3>

          <h1>📞 93639 40150</h1>

          <button>
            Call Now
          </button>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default App;